var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"custom-select",attrs:{"placeholder":"语言"},on:{"change":_vm.handleSetLanguage},model:{value:(_vm.currentLanguage),callback:function ($$v) {_vm.currentLanguage=$$v},expression:"currentLanguage"}},[_c('el-option',{attrs:{"label":"简体","value":"zh"}}),_c('el-option',{attrs:{"label":"En","value":"en"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }